// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"8fdcbe61","140":"1bb7752a","168":"00486d3e","328":"ae183ec1","343":"fefd098e","406":"64cc715c","417":"0ae2cd6e","488":"27fe13dc","591":"708792bd","732":"92d5f522","757":"c8864052","893":"74cbf387","900":"4a277f4d"}[chunkId] + ".chunk.js";
};